import React from 'react';
import { FadeIn } from './FadeIn';
const pillars = [{
  num: 'I',
  title: 'Accesibilidad',
  desc: 'Construimos productos digitales con un precio justo para que el conocimiento llegue a quien lo necesita, sin barreras económicas ni geográficas.'
}, {
  num: 'II',
  title: 'Rigor Editorial',
  desc: 'Cada libro digital pasa por un proceso de curación cuidadoso. Buscamos información práctica, clara y verdaderamente útil para nuestros lectores.'
}, {
  num: 'III',
  title: 'Escala Inteligente',
  desc: 'Aprovechamos la publicidad digital y los funnels Low Ticket para llegar a miles de personas sin perder cercanía ni calidad en la experiencia.'
}, {
  num: 'IV',
  title: 'Visión Global',
  desc: 'Operamos sin sede física y sin fronteras. Nuestro mercado es el mundo entero, y nuestra ambición es estar donde nuestros lectores estén.'
}];
export function Philosophy() {
  return <section id="filosofia" className="py-32 md:py-48 px-6 md:px-12 bg-navy" data-id="element-106" data-mp="kf4iy7wjz7ea">
      <div className="max-w-7xl mx-auto" data-id="element-107" data-mp="kd1v9uivhqcq">
        <FadeIn data-id="element-108" data-mp="17amgj7phjija">
          <div className="flex items-center space-x-6 mb-24" data-id="element-109" data-mp="17a39im1diek1">
            <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-muted" data-id="element-110" data-mp="13a2nogby312y">
              02 — Filosofía
            </span>
            <div className="flex-grow h-[1px] bg-steel" data-id="element-111" data-mp="1h0pkg2y5agwe"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 lg:gap-x-24 lg:gap-y-24" data-id="element-112" data-mp="1c3fp66o2rb0n">
          {pillars.map((pillar, index) => <FadeIn key={pillar.num} delay={index * 0.1} data-id="element-113" data-mp="oed6cvhpfc4k" data-mpi={index}>
              <div className="group" data-id="element-114" data-mp="kc9sy1bh5xgn">
                <div className="flex items-baseline space-x-4 mb-6" data-id="element-115" data-mp="kdb4s80benzf">
                  <span className="font-display text-gold text-xl" data-id="element-116" data-mp="ycaulizkd8x6">
                    {pillar.num}.
                  </span>
                  <h3 className="font-display text-3xl text-cream group-hover:text-white transition-colors duration-500" data-id="element-117" data-mp="tdzjz61g2udw">
                    {pillar.title}
                  </h3>
                </div>
                <p className="text-muted font-light leading-relaxed pl-8 border-l border-steel/30 group-hover:border-steel transition-colors duration-500" data-id="element-118" data-mp="24t61ca65c2u4">
                  {pillar.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}